// Compiled using marko@4.28.10 - DO NOT EDIT
"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry = require("marko/dist/runtime/components/registry"),
    marko_registerComponent = components_registry.r,
    marko_componentType = marko_registerComponent("/wetracker$1.0.0/src/components/sample_list/templates/samples.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    marko_attrs0 = {
        "class": "samples"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("ad60e4"),
    marko_node0 = marko_createElement("div", {
        "class": "controls"
      }, "1", null, 1, 0, {
        i: marko_const_nextId()
      })
      .e("div", {
          "class": "control-panel"
        }, null, null, 1)
        .e("div", {
            "class": "control-group sample-list-buttons"
          }, null, null, 2)
          .e("div", {
              "class": "control"
            }, null, null, 1)
            .e("button", {
                id: "add-sample"
              }, null, null, 1)
              .t("New")
          .e("div", {
              "class": "control"
            }, null, null, 1)
            .e("button", {
                id: "load-sample"
              }, null, null, 1)
              .t("Load"),
    marko_attrs1 = {
        "class": "samples-list"
      },
    marko_node1 = marko_createElement("div", {
        "class": "samples-top-padding"
      }, "9", null, 1, 0, {
        i: marko_const_nextId()
      })
      .e("div", null, null, null, 0),
    marko_node2 = marko_createElement("div", {
        "class": "samples-bottom-padding"
      }, "16", null, 1, 0, {
        i: marko_const_nextId()
      })
      .e("div", null, null, null, 0),
    marko_attrs2 = {
        "class": "samples-index"
      },
    marko_attrs3 = {
        "class": "samples-name"
      };

function render(input, out, __component, component, state) {
  var data = input;

  out.be("div", marko_attrs0, "0", component);

  out.n(marko_node0, component);

  out.be("div", marko_attrs1, "8", component);

  out.n(marko_node1, component);

  if (data.samples) {
    var $for$0 = 0;

    marko_forOf(data.samples, function(i, index) {
      var $keyScope$0 = "[" + (($for$0++) + "]");

      out.e("div", {
          "class": marko_classValue({
              "samples-row": true,
              "current-sample": data.cursor.sample === index
            }),
          "data-sampleindex": "" + index
        }, "11" + $keyScope$0, component, 2)
        .e("div", marko_attrs2, "12" + $keyScope$0, component, 1)
          .e("div", null, "13" + $keyScope$0, component, 1)
            .t(index, component)
        .e("div", marko_attrs3, "14" + $keyScope$0, component, 1)
          .e("div", null, "15" + $keyScope$0, component, 1)
            .t(i.name, component);
    });
  }

  out.n(marko_node2, component);

  out.ee();

  out.ee();
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
